import FetchExt from "../../../../../../medelement/www/assets/js/modules/fetchExt/fetchExt";

export const restoreApi = {
    doRestore: (data) => {
        return FetchExt.postJson('/restore/doRestore', { body: data });
    },
};